import axiosInstance from './axiosInstance';

const baseUrl = 'https://api.kollecta.health';

const login = async (data) => {
  return await axiosInstance.post(`${baseUrl}/api/v1/users/login`, data)
}

const getStatistics = async () => {
  return await axiosInstance.get(`${baseUrl}/api/v1/statistics`)
}

const validate2FA = async (userId, code) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/api/v1/users/validate-2fa`, {
      userId,
      code
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao validar 2FA');
  }
};

const authenticateUser = async (email, password) => {
  try {
    const response = await axiosInstance.post('/api/v1/users/auth', {
      email,
      password
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao autenticar usuário');
  }
};

const resetPassword = async (token, password) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/api/v1/users/set-password`, {
      token,
      password
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao redefinir a senha');
  }
};

const searchProducts = async ({ customerName, personalNumber, studyNumber, type }) => {
  try {
    console.log('Parâmetros de busca:', { customerName, personalNumber, studyNumber, type });
    const response = await axiosInstance.get(`${baseUrl}/api/v1/products/search`, {
      params: { customerName, personalNumber, studyNumber, type }
    });
    console.log('Resposta da API searchProducts:', response.data);
    return response.data;
  } catch (error) {
    // APIs antigas retornavam 404 quando não havia produtos; isso não é falha de busca.
    if (error.response?.status === 404) {
      return {
        success: true,
        data: { products: [], count: 0 },
      };
    }
    console.error('Erro na API searchProducts:', error);
    throw error.response ? error.response.data : new Error('Erro ao buscar produtos');
  }
};

const uploadFile = async (formData, token) => {
  try {
    const config = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    };
    const response = await axiosInstance.post(`${baseUrl}/api/v1/products/import`, formData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao fazer upload do arquivo');
  }
};

const exportCustomersByAnswers = async (filters) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    };
    const response = await axiosInstance.post(`${baseUrl}/api/v1/customers/export-by-answer`, { filters }, config);

    return response.data;
  } catch (error) {
    throw error.response ? error.response?.data : new Error('Erro ao exportar dados dos clientes');
  }
};

const exportBotHistoryExcel = async (personalNumber, botType) => {
  try {
    const config = {
      headers: {
      },
      responseType: 'blob',
      params: {}
    };
    if (botType) {
      config.params.botType = botType;
    }
    const response = await axiosInstance.get(`${baseUrl}/api/v1/bot-history/export/excel/${personalNumber}`, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao exportar o histórico do bot');
  }
};

const getLastTwoBotHistories = async (personalNumber, botType) => {
  try {
    const params = {};
    if (botType) {
      params.botType = botType;
    }
    const response = await axiosInstance.get(`${baseUrl}/api/v1/bot-history/last-two/${personalNumber}`, {
      params
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao recuperar os últimos dois históricos do bot');
  }
};

const updateProduct = async (productId, productData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.put(`${baseUrl}/api/v1/products/${productId}`, productData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar produto');
  }
};

const updateTreatment = async (treatmentId, treatmentData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      },
    };
    const response = await axiosInstance.put(`${baseUrl}/api/v1/treatments/${treatmentId}`, treatmentData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar tratamento');
  }
};

const createTreatment = async (treatmentData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      },
    };
    const response = await axiosInstance.post(`${baseUrl}/api/v1/treatments`, treatmentData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar tratamento');
  }
};

const getBotHistoryByPersonalNumber = async (personalNumber, startDate, endDate, botType) => {
  try {
    const params = { startDate, endDate };
    if (botType) {
      params.botType = botType;
    }
    const response = await axiosInstance.get(`${baseUrl}/api/v1/bot-history/by-personal-number/${personalNumber}`, {
      params
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao recuperar o histórico do bot');
  }
};

const initiateResetPassword = async (email) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/api/v1/users/reset-password`, { email });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao iniciar a redefinição de senha');
  }
};

const exportBotHistoryPDF = async (personalNumber, botType, startDate, endDate) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
      params: {}
    };
    if (botType) {
      config.params.botType = botType;
    }
    if (startDate && endDate) {
      config.params.startDate = startDate;
      config.params.endDate = endDate;
    }
    const response = await axiosInstance.get(`${baseUrl}/api/v1/bot-history/export/pdf/${personalNumber}`, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao exportar o histórico do bot em PDF');
  }
};

const upsertCustomer = async (customerData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.post(`${baseUrl}/api/v1/customers`, customerData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao criar cliente');
  }
};

const createProduct = async (productData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.post(`${baseUrl}/api/v1/products`, productData, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao criar produto');
  }
};

const updateProductField = async (productId, fieldName, newValue) => {
  try {
    console.log('updateProductField - Chamada da API:', {
      productId,
      fieldName,
      newValue,
      url: `${baseUrl}/api/v1/products/update-field/${productId}`,
      payload: { fieldName, newValue }
    });
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/products/update-field/${productId}`,
      { fieldName, newValue },
      config
    );
    
    console.log('updateProductField - Resposta da API:', response.data);
    return response.data;
  } catch (error) {
    console.error('updateProductField - Erro na API:', error);
    throw error.response ? error.response.data : new Error('Erro ao atualizar campo do produto');
  }
};

const updateTreatmentField = async (treatmentId, fieldName, newValue) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/treatments/update-field/${treatmentId}`,
      { fieldName, newValue },
      config
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar campo do tratamento');
  }
};

const getMedications = async (name, category) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const params = {};
    if (name) {
      params.name = name;
    }
    if (category) {
      params.category = category;
    }
    const response = await axiosInstance.get(`${baseUrl}/api/v1/medications`, {
      params,
      ...config
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar medicamentos');
  }
};

const linkMedicationToTreatment = async (treatmentId, medicationData) => {
  try {
    console.log('linkMedicationToTreatment chamado com:', { treatmentId, medicationData });
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    
    let requestData;
    
    if (medicationData.medication && medicationData.interval) {
      console.log('Usando formato antigo');
      requestData = {
        treatment: {
          connect: {
            id: treatmentId
          }
        },
        medication: {
          connect: {
            id: medicationData.medication
          }
        },
        dosage: medicationData.dosage || "",
        observations: medicationData.observations || "",
        frequency: medicationData.interval
      };
    } else if (medicationData.medication?.connect?.id) {
      console.log('Usando formato novo');
      requestData = {
        treatment: {
          connect: {
            id: treatmentId
          }
        },
        ...medicationData
      };
    } else {
      console.log('Usando formato intermediário');
      requestData = {
        treatment: {
          connect: {
            id: treatmentId
          }
        },
        medication: {
          connect: {
            id: medicationData.medicationId
          }
        },
        dosage: medicationData.dosage || "",
        observations: medicationData.observations || "",
        frequency: medicationData.frequency
      };
    }
    
    console.log('Dados finais para requisição:', requestData);
    
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/treatment-medications`,
      requestData,
      config
    );
    console.log('Resposta da API:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro em linkMedicationToTreatment:', error);
    throw error.response ? error.response.data : new Error('Erro ao vincular medicamento ao tratamento');
  }
};

const getTreatmentMedications = async (treatmentId) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/treatments/${treatmentId}/medications`,
      config
    );
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar medicamentos do tratamento');
  }
};

const getPainMetrics = async () => {
  try {
    console.log('Chamando API de métricas de dor...');
    const response = await axiosInstance.get(`${baseUrl}/api/v1/metrics/pain`);
    console.log('Resposta da API de métricas de dor:', response);
    return response;
  } catch (error) {
    console.error('Erro ao buscar métricas de dor:', error);
    throw error;
  }
};

const getEffectsMetrics = async () => {
  try {
    console.log('Chamando API de métricas de efeitos adversos...');
    const response = await axiosInstance.get(`${baseUrl}/api/v1/metrics/effects-adverse`);
    console.log('Resposta da API de métricas de efeitos adversos:', response);
    return response;
  } catch (error) {
    console.error('Erro ao buscar métricas de efeitos adversos:', error);
    throw error;
  }
};

const exportPainMetrics = async (filterType = 'all', dateParams = '') => {
  try {
    const url = dateParams 
      ? `${baseUrl}/api/v1/metrics/pain/export?filterType=${filterType}&${dateParams}`
      : `${baseUrl}/api/v1/metrics/pain/export?filterType=${filterType}`;
      
    const response = await axiosInstance({
      url,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao exportar métricas de dor:', error);
    throw error;
  }
};

const exportEffectsMetrics = async (filterType = 'all', dateParams = '') => {
  try {
    const url = dateParams 
      ? `${baseUrl}/api/v1/metrics/effects-adverse/export?filterType=${filterType}&${dateParams}`
      : `${baseUrl}/api/v1/metrics/effects-adverse/export?filterType=${filterType}`;
      
    const response = await axiosInstance({
      url,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao exportar métricas de efeitos adversos:', error);
    throw error;
  }
};

const exportSurgeryMetrics = async (filterType = 'all', dateParams = '') => {
  try {
    const url = dateParams
      ? `${baseUrl}/api/v1/metrics/surgeries/export?filterType=${filterType}&${dateParams}`
      : `${baseUrl}/api/v1/metrics/surgeries/export?filterType=${filterType}`;

    const response = await axiosInstance({
      url,
      method: 'get',
      responseType: 'blob',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao exportar métricas de cirurgias:', error);
    throw error;
  }
};

const getEffectsAdversePatients = async (page = 1, limit = 20) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/api/v1/effects-adverse/patients`, {
      params: { page, limit }
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar pacientes de efeitos adversos:', error);
    throw error.response ? error.response.data : new Error('Erro ao buscar pacientes de efeitos adversos');
  }
};

const getSurgeryProfile = async (productId) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/api/v1/cirurgias/profiles/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar perfil cirúrgico:', error);
    throw error.response ? error.response.data : new Error('Erro ao buscar perfil cirúrgico');
  }
};

const createOrUpdateSurgeryProfile = async (productId, profileData) => {
  try {
    const response = await axiosInstance.post(`${baseUrl}/api/v1/cirurgias/profiles`, {
      productId,
      data: profileData
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao salvar perfil cirúrgico:', error);
    throw error.response ? error.response.data : new Error('Erro ao salvar perfil cirúrgico');
  }
};

const updateSurgeryProfile = async (productId, profileData) => {
  try {
    const response = await axiosInstance.put(`${baseUrl}/api/v1/cirurgias/profiles/${productId}`, profileData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar perfil cirúrgico:', error);
    throw error.response ? error.response.data : new Error('Erro ao atualizar perfil cirúrgico');
  }
};

export {
  login,
  validate2FA,
  authenticateUser,
  resetPassword,
  initiateResetPassword,
  searchProducts,
  uploadFile,
  getStatistics,
  getPainMetrics,
  getEffectsMetrics,
  exportPainMetrics,
  exportEffectsMetrics,
  exportSurgeryMetrics,
  exportCustomersByAnswers,
  exportBotHistoryExcel,
  getLastTwoBotHistories,
  updateProduct,
  updateTreatment,
  getBotHistoryByPersonalNumber,
  createTreatment,
  exportBotHistoryPDF,
  upsertCustomer,
  createProduct,
  updateProductField,
  updateTreatmentField,
  getMedications,
  linkMedicationToTreatment,
  getTreatmentMedications,
  getEffectsAdversePatients,
  getSurgeryProfile,
  createOrUpdateSurgeryProfile,
  updateSurgeryProfile
}